import { render, staticRenderFns } from "./AfterPayment.vue?vue&type=template&id=e423847c&scoped=true"
import script from "./AfterPayment.vue?vue&type=script&lang=js"
export * from "./AfterPayment.vue?vue&type=script&lang=js"
import style0 from "./AfterPayment.vue?vue&type=style&index=0&id=e423847c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e423847c",
  null
  
)

export default component.exports